module.exports = __webpack_public_path__ + "static/media/Booklet-MentalHealth.468a4078.pdf";